[
  {
    "key": "txtQNew",
    "text": "Q",
    "translations": [
      {
        "language": "AR",
        "text": "س"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "FR",
        "text": "Pour"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txtFillAllCriteriaFields",
    "text": "Please, fill all required criteria",
    "translations": [
      {
        "language": "AR",
        "text": "الرجاء تعبئة الحقول المطلوبة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txtQ",
    "text": "S",
    "translations": [
      {
        "language": "AR",
        "text": "ع"
      },
      {
        "language": "FR",
        "text": "Q"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_min_to",
    "text": "5 ~ 10 min",
    "translations": [
      {
        "language": "AR",
        "text": "من 5 إلى 10 دقائق"
      },
      {
        "language": "FR",
        "text": "5 ~ 10 min"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSurveyComplete",
    "text": "The survey has been completed.",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تم إكمال الاستبيان."
      },
      {
        "language": "FR",
        "text": "l’enquête est terminée."
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण पूरा हो चुका है।"
      },
      {
        "language": "TA",
        "text": "Nakumpleto na ang survey."
      },
      {
        "language": "UR",
        "text": "سروے مکمل ہو چکا ہے۔"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা সম্পন্ন হয়েছে।"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSurveyCompleteTitle",
    "text": "Survey Completed",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال الاستبيان"
      },
      {
        "language": "FR",
        "text": "enquête terminée"
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण पूरा हुआ"
      },
      {
        "language": "TA",
        "text": "Nakumpleto ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے مکمل ہوا"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা সম্পন্ন হয়েছে"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAssessmentComplete",
    "text": "The assessment has been completed.",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تم إكمال التقييم."
      },
      {
        "language": "FR",
        "text": "Le Enquęte est terminé."
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण पूरा हो चुका है।"
      },
      {
        "language": "TA",
        "text": "Nakumpleto na ang survey."
      },
      {
        "language": "UR",
        "text": "سروے مکمل ہو چکا ہے۔"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAssessmentCompleteTitle",
    "text": "Assessment Completed",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال التقييم"
      },
      {
        "language": "FR",
        "text": "Enquęte Terminé"
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण पूरा हुआ"
      },
      {
        "language": "TA",
        "text": "Nakumpleto ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے مکمل ہوا"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_start_survey",
    "text": "Start Survey",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ الاستبيان"
      },
      {
        "language": "FR",
        "text": "Commencer l'Évaluation "
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण शुरू करें"
      },
      {
        "language": "TA",
        "text": "Simulan ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے شروع کریں"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা আরম্ভ করুন"
      },
      {
        "language": "NL",
        "text": "Start onderzoek"
      },
      {
        "language": "ES",
        "text": "empezar encuesta"
      },
      {
        "language": "LA",
        "text": "satus circumspectis"
      },
      {
        "language": "ML",
        "text": "സർവേ ആരംഭിക്കുക"
      },
      {
        "language": "ID",
        "text": "memulai survei"
      },
      {
        "language": "NE",
        "text": "सर्वेक्षण सुरु गर्नुहोस्"
      },
      {
        "language": "SI",
        "text": "සමීක්ෂණය ආරම්භ කරන්න"
      }
    ]
  },
  {
    "key": "txt_start_assessment",
    "text": "Start",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ "
      },
      {
        "language": "FR",
        "text": "Commencer l'Évaluation "
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण शुरू करें"
      },
      {
        "language": "TA",
        "text": "Simulan ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے شروع کریں"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      },
      {
        "language": "TR",
        "text": "Başla"
      }
    ]
  },
  {
    "key": "txt_360_q_welcome",
    "text": "Thank you for taking the time to fill out the 360° Feedback Assessment. Your honest feedback is highly appreciated. Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. However, the results of the assessment will be used for research and improvement purposes by the Human Resources Team.\n  <br><br>\nDisclaimer: All information pertaining to this assessment shall remain anonymous and shall not be disclosed to anyone.\n",
    "translations": [
      {
        "language": "AR",
        "text": "نشكرك لمشاركتك في هذا التقييم.\nأجوبتك النزيهة والصريحة مهمة لنا.\n\nيرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا التقييم سرية للغاية وستبقى هويتك مجهولة.\nوتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n\nإخلاء المسؤولية: جميع المعلومات المتعلقة بهذا التقييم سرية ولن يتم الإفصاح عنها لأي جهة.\n"
      },
      {
        "language": "FR",
        "text": "Merci d'avoir pris le temps de remplir l'évaluation de rétroaction à 360 °. Votre rétroaction honnête est très appréciée. Veuillez noter que vos réponses sont strictement confidentielles et que votre identité restera anonyme tout au long du processus. Cependant, les résultats de l'évaluation sera utilisé à des fins de recherche et d'amélioration par l'équipe des ressources humaines. Avis de non-responsabilité: Toutes les informations relatives à cette évaluation resteront anonymes et ne seront divulguées à personne."
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_180_q_welcome",
    "text": "Thank you for taking the time to fill out the 180° Feedback Assessment. Your honest feedback is highly appreciated. Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. However, the results of the assessment will be used for research and improvement purposes by the Human Resources Team.\n  <br><br>\nDisclaimer: All information pertaining to this assessment shall remain anonymous and shall not be disclosed to anyone.\n",
    "translations": [
      {
        "language": "AR",
        "text": "نشكرك لمشاركتك في هذا التقييم.\nأجوبتك النزيهة والصريحة مهمة لنا.\n\nيرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا التقييم سرية للغاية وستبقى هويتك مجهولة.\nوتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n\nإخلاء المسؤولية: جميع المعلومات المتعلقة بهذا التقييم سرية ولن يتم الإفصاح عنها لأي جهة.\n"
      },
      {
        "language": "FR",
        "text": "Merci d'avoir pris le temps de remplir l'évaluation de rétroaction à 180 °. Votre rétroaction honnête est très appréciée. Veuillez noter que vos réponses sont strictement confidentielles et que votre identité restera anonyme tout au long du processus. Cependant, les résultats de l'évaluation sera utilisé à des fins de recherche et d'amélioration par l'équipe des ressources humaines. Avis de non-responsabilité: Toutes les informations relatives à cette évaluation resteront anonymes et ne seront divulguées à personne."
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_your",
    "text": "your",
    "translations": [
      {
        "language": "AR",
        "text": "الخاص بك"
      },
      {
        "language": "FR",
        "text": "Votre"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_you",
    "text": "you",
    "translations": [
      {
        "language": "AR",
        "text": "أنت"
      },
      {
        "language": "FR",
        "text": "Vous"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_360_q_thank_you",
    "text": "Your responses have been submitted successfully.\nThank you for completing the assessment and providing your feedback.\n",
    "translations": [
      {
        "language": "AR",
        "text": "تم استلام جميع ردودك بنجاح!\nنشكرك على وقتك المبذول في تعبئة هذا التقييم.\n  "
      },
      {
        "language": "FR",
        "text": "Vos réponses ont été soumises avec succès. Merci d'avoir terminé l'évaluation et de nous avoir fait part de vos commentaires."
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt360DegreeFeedback",
    "text": "360° Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360"
      },
      {
        "language": "FR",
        "text": "Commentaire ŕ 360°"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt180DegreeAssessment",
    "text": "180° Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °180"
      },
      {
        "language": "FR",
        "text": "Commentaire ŕ 180°"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_happiness_q_welcome",
    "text": "\nThank you for taking the time to fill out the Employee Happiness survey.<br> Your honest feedback is highly appreciated.<br> Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process.<br> However, the results of the survey will be used for research and improvement purposes by the Human Resources Team.\n<br><br>\nDisclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone.\n",
    "translations": [
      {
        "language": "AR",
        "text": "نشكرك لمشاركتك في هذا الاستبيان.\n  أجوبتك النزيهة والصريحة مهمة لنا.\n  <br>\n  يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وستبقى هويتك مجهولة.\n  وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n  <br>\n  إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا الاستبيان سرية ولن يتم الإفصاح عنها لأي جهة.\n  "
      },
      {
        "language": "NL",
        "text": "Bedankt dat u de tijd heeft genomen om de medewerkersbetrokkenheidsenquête in te vullen.<br> Uw eerlijke feedback wordt zeer op prijs gesteld. <br> Houd er rekening mee dat uw antwoorden strikt vertrouwelijk zijn en dat uw identiteit gedurende het gehele proces anoniem blijft. <br> De resultaten van de enquête zullen echter worden gebruikt voor onderzoeks- en verbeteringsdoeleinden door het Human Resources-team. <br><br> Disclaimer: Alle informatie met betrekking tot dit onderzoek blijft anoniem en wordt aan niemand bekendgemaakt."
      },
      {
        "language": "ES",
        "text": "Gracias por tomarse el tiempo de completar la encuesta sobre Compromiso de los Empleados.<br> Agradecemos mucho sus comentarios honestos.<br> Tenga en cuenta que sus respuestas son estrictamente confidenciales y su identidad permanecerá anónima durante todo el proceso.<br> Sin embargo, el equipo de Recursos Humanos utilizará los resultados de la encuesta con fines de investigación y mejora.<br><br>Descargo de responsabilidad: toda la información relativa a esta encuesta permanecerá anónima y no se divulgará a nadie."
      },
      {
        "language": "LA",
        "text": "Gratias tibi ago quod tempus sumendo ad implendum Concursationem Aliquam.<br> Honesta responsionis magni aestimantur.<br> Nota quaeso responsiones tuas stricte secretas esse, et identitas tua per totum processum anonymum remanebit. Sed eventus recognitionis adhibebitur ad investigationes et emendationes proposita ab Humanis Resources Team.<br><br>Disclaimer: Omnis notitia ad hanc extensionem pertinens anonyma manebit nec cuiquam patebit."
      },
      {
        "language": "ML",
        "text": "ജീവനക്കാരുടെ ഇടപഴകൽ സർവേ പൂരിപ്പിക്കാൻ സമയമെടുത്തതിന് നന്ദി.<br> നിങ്ങളുടെ സത്യസന്ധമായ ഫീഡ്‌ബാക്ക് വളരെ വിലമതിക്കപ്പെടുന്നു.<br> നിങ്ങളുടെ പ്രതികരണങ്ങൾ കർശനമായി രഹസ്യാത്മകമാണെന്നും നിങ്ങളുടെ ഐഡൻ്റിറ്റി മുഴുവൻ പ്രക്രിയയിലുടനീളം അജ്ഞാതമായി തുടരുമെന്നും ദയവായി ശ്രദ്ധിക്കുക.<br> എന്നിരുന്നാലും, സർവേയുടെ ഫലങ്ങൾ ഹ്യൂമൻ റിസോഴ്‌സ് ടീം ഗവേഷണത്തിനും മെച്ചപ്പെടുത്തൽ ആവശ്യങ്ങൾക്കും ഉപയോഗിക്കും.<br><br>നിരാകരണം: ഈ സർവേയുമായി ബന്ധപ്പെട്ട എല്ലാ വിവരങ്ങളും അജ്ഞാതമായി തുടരും, അത് ആരോടും വെളിപ്പെടുത്തില്ല."
      },
      {
        "language": "ID",
        "text": "Terima kasih telah meluangkan waktu untuk mengisi survei Keterlibatan Karyawan.<br> Masukan jujur Anda sangat kami hargai.<br> Harap perhatikan bahwa tanggapan Anda sangat rahasia, dan identitas Anda akan tetap anonim selama seluruh proses.<br> Namun, hasil survei akan digunakan untuk tujuan penelitian dan perbaikan oleh Tim Sumber Daya Manusia.<br><br>Penafian: Semua informasi yang berkaitan dengan survei ini akan tetap anonim dan tidak boleh diungkapkan kepada siapa pun."
      },
      {
        "language": "NE",
        "text": "कर्मचारी संलग्नता सर्वेक्षण भर्नको लागि समय दिनुभएकोमा धन्यवाद।<br> तपाईंको इमानदार प्रतिक्रियाको अत्यधिक सराहना गरिन्छ।<br> कृपया ध्यान दिनुहोस् कि तपाईंका प्रतिक्रियाहरू पूर्ण रूपमा गोप्य छन्, र सम्पूर्ण प्रक्रियामा तपाईंको पहिचान गुमनाम रहनेछ।<br> यद्यपि, सर्वेक्षणको नतिजाहरू मानव संसाधन टोलीद्वारा अनुसन्धान र सुधार उद्देश्यका लागि प्रयोग गरिनेछ।<br><br>अस्वीकरण: यस सर्वेक्षणसँग सम्बन्धित सबै जानकारी गुमनाम रहनेछ र कसैलाई पनि खुलासा गरिने छैन।"
      },
      {
        "language": "SI",
        "text": "සේවක නියැලීමේ සමීක්ෂණය පිරවීමට කාලය ගත කිරීම ගැන ඔබට ස්තුතියි.<br> ඔබේ අවංක ප්‍රතිපෝෂණය බෙහෙවින් අගය කරනු ලැබේ.<br> ඔබේ ප්‍රතිචාර දැඩි ලෙස රහස්‍ය වන අතර, ඔබේ අනන්‍යතාවය සම්පූර්ණ ක්‍රියාවලිය පුරාම නිර්නාමිකව පවතිනු ඇති බව කරුණාවෙන් සලකන්න.<br> කෙසේ වෙතත්, සමීක්ෂණයේ ප්‍රතිඵල මානව සම්පත් කණ්ඩායම විසින් පර්යේෂණ සහ වැඩිදියුණු කිරීමේ අරමුණු සඳහා භාවිත කරනු ඇත.<br><br>වියයාචනය: මෙම සමීක්ෂණයට අදාළ සියලුම තොරතුරු නිර්නාමිකව පවතින අතර කිසිවෙකුට හෙළිදරව් නොකළ යුතුය."
      },
      {
        "language": "HI",
        "text": "कर्मचारी सहभागिता सर्वेक्षण को भरने के लिए समय निकालने के लिए धन्यवाद।<br> आपकी ईमानदार प्रतिक्रिया की अत्यधिक सराहना की जाती है।<br> कृपया ध्यान दें कि आपकी प्रतिक्रियाएँ पूरी तरह से गोपनीय हैं, और पूरी प्रक्रिया के दौरान आपकी पहचान गुमनाम रहेगी।<br> हालाँकि, सर्वेक्षण के परिणामों का उपयोग मानव संसाधन टीम द्वारा अनुसंधान और सुधार उद्देश्यों के लिए किया जाएगा।<br><br>अस्वीकरण: इस सर्वेक्षण से संबंधित सभी जानकारी गुमनाम रहेगी और किसी के सामने प्रकट नहीं की जाएगी।"
      },
      {
        "language": "TA",
        "text": "Salamat sa paglalaan ng oras upang punan ang survey sa Employee Engagement.<br> Ang iyong tapat na feedback ay lubos na pinahahalagahan.<br> Pakitandaan na ang iyong mga tugon ay mahigpit na kumpidensyal, at ang iyong pagkakakilanlan ay mananatiling anonymous sa buong proseso.<br> Gayunpaman, ang mga resulta ng survey ay gagamitin para sa mga layunin ng pananaliksik at pagpapabuti ng Human Resources Team.<br><br>Disclaimer: Ang lahat ng impormasyon na nauukol sa survey na ito ay mananatiling anonymous at hindi dapat ibunyag sa sinuman."
      },
      {
        "language": "UR",
        "text": "ملازم کی مصروفیت کے سروے کو پُر کرنے کے لیے وقت نکالنے کے لیے آپ کا شکریہ۔<br> آپ کے ایماندارانہ تاثرات کی بہت تعریف کی جاتی ہے۔<br> براہ کرم نوٹ کریں کہ آپ کے جوابات سختی سے رازدارانہ ہیں، اور آپ کی شناخت پوری کارروائی کے دوران گمنام رہے گی۔<br> تاہم، سروے کے نتائج انسانی وسائل کی ٹیم کی جانب سے تحقیق اور بہتری کے مقاصد کے لیے استعمال کیے جائیں گے۔<br><br>اعلان: اس سروے سے متعلق تمام معلومات گمنام رہیں گی اور کسی کو بھی ظاہر نہیں کی جائیں گی۔"
      },
      {
        "language": "BN",
        "text": "Bedankt dat u de tijd heeft genomen om de medewerkersbetrokkenheidsenquête in te vullen.<br> Uw eerlijke feedback wordt zeer op prijs gesteld.<br> Houd er rekening mee dat uw antwoorden strikt vertrouwelijk zijn en dat uw identiteit gedurende het hele proces anoniem blijft.<br> De resultaten van de enquête zullen echter worden gebruikt voor onderzoeks- en verbeteringsdoeleinden door het Human Resources-team.<br><br>Disclaimer: Alle informatie met betrekking tot deze enquête blijft anoniem en wordt aan niemand bekendgemaakt."
      }
    ]
  },
  {
    "key": "txt_leaver_q_welcome",
    "text": "\n  Thank you for taking the time to fill out the Employee Exit survey.<br> Your honest feedback is highly appreciated.<br> Please note that your responses are strictly confidential and are only used for research and improvement purposes by the Human Resources Team.\n",
    "translations": [
      {
        "language": "AR",
        "text": "\n  نشكرك لمشاركتك في هذا الاستبيان.\n  أجوبتك النزيهة والصريحة مهمة لنا.\n  <br>\n  يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وتستخدم فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n"
      },
      {
        "language": "FR",
        "text": "Madame, Monsieur\n<br><br>\nNous vous invitons à participer au questionnaire ci-dessous et d'y répondre avec vigilance. Votre participation et vos réponses ainsi que tous les résultats obtenus à partir de ce questionnaire sont strictement confidentiels et ne sont utilisés qu'à des fins de recherche et d'amélioration par l'équipe des ressources humaines.\nVotre coopération et vos observations sont très appréciés.\n\n<br><br>\n"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_employee_exitSurvey",
    "text": "Employee Exit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان خروج الموظفين"
      },
      {
        "language": "FR",
        "text": "Enquête départ collaborateur"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txtLoader",
    "text": "Please wait...",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى الانتظار..."
      },
      {
        "language": "FR",
        "text": "S'il vous plaît, attendez..."
      },
      {
        "language": "HI",
        "text": "कृपया प्रतीक्षा करें…"
      },
      {
        "language": "TA",
        "text": "Mangyaring maghintay…"
      },
      {
        "language": "UR",
        "text": "براہ کرم انتظار کریں۔۔۔"
      },
      {
        "language": "BN",
        "text": "অনুগ্রহপূর্বক অপেক্ষা করুন…"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_engagement_q_welcome",
    "text": "\nThank you for taking the time to fill out the Employee Engagement survey.<br> Your honest feedback is highly appreciated.<br> Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process.<br> However, the results of the survey will be used for research and improvement purposes by the Human Resources Team.\n<br><br>\nDisclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone.\n",
    "translations": [
      {
        "language": "AR",
        "text": "نشكرك لمشاركتك في هذا الاستبيان.\n  أجوبتك النزيهة والصريحة مهمة لنا.\n  <br>\n  يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وستبقى هويتك مجهولة.\n  وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n  <br>\n  إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا الاستبيان سرية ولن يتم الإفصاح عنها لأي جهة.\n  "
      },
      {
        "language": "FR",
        "text": "Merci d'avoir pris le temps de remplir le Enquête sur l'engagement des employés.  Vos commentaires honnêtes sont très appréciés.  Veuillez noter que vos réponses sont strictement confidentielles et que votre identité restera anonyme tout au long du processus. Toutefois, les résultats de Enquête seront utilisés à des fins de recherche et d’amélioration par l’équipe des ressources humaines. Désistement: Toutes les informations relatives à ce Enquête resteront anonymes et ne seront divulguées à personne."
      },
      {
        "language": "HI",
        "text": "\nकर्मचारी सहभागिता सर्वेक्षण को भरने के लिए समय निकालने के लिए धन्यवाद।<br> आपकी ईमानदार प्रतिक्रिया की अत्यधिक सराहना की जाती है।<br> कृपया जान लें कि आपके जवाब पूरी तरह से गोपनीय हैं, और पूरी प्रक्रिया के दौरान आपकी पहचान गुमनाम रहेगी।<br> लेकिन सर्वेक्षण के परिणामों का उपयोग मानव संसाधन टीम या दाल द्वारा अनुसंधान और सुधार उद्देश्यों के लिए किया जाएगा।\n<br><br>\nइस सर्वेक्षण से संबंधित सभी जानकारी गुमनाम रहेगी और किसी को भी इसका खुलासा नहीं किया जाएगा।\n"
      },
      {
        "language": "TA",
        "text": "\nSalamat sa paglalaan ng oras upang punan ang survey ng Employee Engagement.<br> Ang iyong matapat na feedback ay lubos na pinahahalagahan.<br> Pakitandaan na ang iyong mga tugon ay mahigpit na kumpidensyal, at ang iyong pagkakakilanlan ay mananatiling hindi nagpapakilala sa buong proseso.<br>Gayunpaman, ang mga resulta ng survey ay gagamitin para sa pananaliksik at pagpapabuti ng mga layunin ng Human Resources Team.\n<br><br>\nAng lahat ng impormasyon na nauukol sa survey na ito ay mananatiling hindi nagpapakilala at hindi dapat ibunyag sa sinuman.\n"
      },
      {
        "language": "UR",
        "text": "\nملازم کی مصروفیت کے سروے کو پر کرنے کے واسطے وقت نکالنے کے لیے آپ کا شکریہ۔<br> آپ کے ایماندارانہ تاثرات انتہائی قابل تعریف ہیں۔<br>براہ کرم نوٹ کریں کہ آپ کے جوابات انتہائی خفیہ ہیں، اور آپ کی شناخت اس پورے عمل کے دوران گمنام رہے گی۔<br>تاہم، سروے کے نتائج کو انسانی وسائل کی ٹیم کے ذریعہ تحقیق اور اصلاح کے مقاصد کے لیے استعمال کیا جائے گا۔\n<br><br>\nاس سروے سے تعلق رکھنے والی تمام معلومات گمنام رہیں گی اور کسی کے لیے بھی ظاہر نہیں کی جائیں گی۔\n"
      },
      {
        "language": "BN",
        "text": "\nকর্মচারী নিযুক্তি সমীক্ষাটি পূরণ করতে সময় দেওয়ার জন্য আপনাকে ধন্যবাদ৷<br> আপনার সৎ প্রতিক্রিয়া অত্যন্ত প্রশংসাযোগ্য৷<br> অনুগ্রহ করে মনে রাখবেন যে আপনার প্রতিক্রিয়াগুলি অত্যন্ত গোপনীয়, এবং পুরো প্রক্রিয়ায় আপনার পরিচয় অজ্ঞাত থাকবে।<br> যাইহোক, সমীক্ষার ফলটি মানব সম্পদ দল দ্বারা গবেষণা এবং উন্নতির উদ্দেশ্যে ব্যবহার করা হবে।\n<br><br>\nডিসক্লেইমার: এই সমীক্ষার সাথে সম্পর্কিত সমস্ত তথ্য অজ্ঞাত থাকবে এবং কাউকে প্রকাশ করা হবে না।\n"
      },
      {
        "language": "NL",
        "text": "Bedankt dat u de tijd heeft genomen om de medewerkersbetrokkenheidsenquête in te vullen.<br> Uw eerlijke feedback wordt zeer op prijs gesteld. <br> Houd er rekening mee dat uw antwoorden strikt vertrouwelijk zijn en dat uw identiteit gedurende het gehele proces anoniem blijft. <br> De resultaten van de enquête zullen echter worden gebruikt voor onderzoeks- en verbeteringsdoeleinden door het Human Resources-team. <br><br> Disclaimer: Alle informatie met betrekking tot dit onderzoek blijft anoniem en wordt aan niemand bekendgemaakt."
      },
      {
        "language": "ES",
        "text": "Gracias por tomarse el tiempo para completar la encuesta sobre participación de los empleados. <br> Sus comentarios honestos son muy apreciados. <br> Tenga en cuenta que sus respuestas son estrictamente confidenciales y su identidad permanecerá anónima durante todo el proceso. <br> Sin embargo, los resultados de la encuesta serán utilizados con fines de investigación y mejora por parte del Equipo de Recursos Humanos. <br><br> Descargo de responsabilidad: Toda la información relativa a esta encuesta permanecerá anónima y no será revelada a nadie."
      },
      {
        "language": "LA",
        "text": "Gratias tibi ago pro accipiendo tempus implendum exspectu Employee Engagement. <br> Honesta videre magni. <br> Nota quaeso responsiones tuas stricte secretas esse, et identitas tua per totum processum anonymum remanebit. <br> Sed eventus circumspectionis adhibebitur ad investigationes et emendationes proposita ab Humanis Resources Team. <br><br> Disclaimer: Omnia informationes ad hanc recognitionem pertinentia anonyma manebunt et nulli patefientur."
      },
      {
        "language": "ML",
        "text": "ജീവനക്കാരുടെ ഇടപഴകൽ സർവേ പൂരിപ്പിക്കാൻ സമയമെടുത്തതിന് നന്ദി. <br> നിങ്ങളുടെ സത്യസന്ധമായ പ്രതികരണം വളരെ വിലമതിക്കപ്പെടുന്നു. <br> നിങ്ങളുടെ പ്രതികരണങ്ങൾ കർശനമായി രഹസ്യമാണെന്നും നിങ്ങളുടെ ഐഡൻ്റിറ്റി മുഴുവൻ പ്രക്രിയയിലുടനീളം അജ്ഞാതമായി തുടരുമെന്നും ദയവായി ശ്രദ്ധിക്കുക. <br> എന്നിരുന്നാലും, സർവേയുടെ ഫലങ്ങൾ ഹ്യൂമൻ റിസോഴ്‌സ് ടീം ഗവേഷണത്തിനും മെച്ചപ്പെടുത്തൽ ആവശ്യങ്ങൾക്കും ഉപയോഗിക്കും.<br><br> നിരാകരണം: ഈ സർവേയുമായി ബന്ധപ്പെട്ട എല്ലാ വിവരങ്ങളും അജ്ഞാതമായി തുടരും, ആരോടും വെളിപ്പെടുത്താൻ പാടില്ല."
      },
      {
        "language": "ID",
        "text": "Terima kasih telah meluangkan waktu untuk mengisi survei Keterlibatan Karyawan. <br> Masukan jujur Anda sangat kami hargai. <br> Harap dicatat bahwa tanggapan Anda sangat rahasia, dan identitas Anda akan tetap anonim selama seluruh proses. <br> Namun hasil survei tersebut akan digunakan untuk keperluan penelitian dan perbaikan oleh Tim Sumber Daya Manusia. <br><br> Penafian: Semua informasi yang berkaitan dengan survei ini akan tetap anonim dan tidak boleh diungkapkan kepada siapa pun."
      },
      {
        "language": "NE",
        "text": "कर्मचारी संलग्नता सर्वेक्षण भर्नको लागि समय दिनुभएकोमा धन्यवाद।<br> तपाईंको इमानदार प्रतिक्रिया अत्यधिक सराहना गरिएको छ। <br> कृपया ध्यान दिनुहोस् कि तपाईंका प्रतिक्रियाहरू कडा रूपमा गोप्य छन्, र तपाईंको पहिचान सम्पूर्ण प्रक्रियामा गुमनाम रहनेछ। <br> यद्यपि, सर्वेक्षणको नतिजालाई मानव संसाधन टोलीद्वारा अनुसन्धान र सुधारका लागि प्रयोग गरिनेछ। <br><br> अस्वीकरण: यस सर्वेक्षणसँग सम्बन्धित सबै जानकारी गुमनाम रहनेछ र कसैलाई पनि खुलासा गरिने छैन।"
      },
      {
        "language": "SI",
        "text": "සේවක නියැලීමේ සමීක්ෂණය පිරවීමට කාලය ගත කිරීම ගැන ඔබට ස්තුතියි. <br> ඔබගේ අවංක ප්‍රතිපෝෂණය බෙහෙවින් අගය කරනු ලැබේ. <br> ඔබගේ ප්‍රතිචාර දැඩි ලෙස රහසිගත බවත්, ඔබගේ අනන්‍යතාවය සම්පූර්ණ ක්‍රියාවලිය පුරාම නිර්නාමිකව පවතින බවත් කරුණාවෙන් සලකන්න. <br> කෙසේ වෙතත්, සමීක්ෂණයේ ප්රතිඵල මානව සම්පත් කණ්ඩායම විසින් පර්යේෂණ සහ වැඩිදියුණු කිරීමේ අරමුණු සඳහා භාවිතා කරනු ඇත. <br><br> වියාචනය: මෙම සමීක්ෂණයට අදාළ සියලුම තොරතුරු නිර්නාමිකව පවතින අතර කිසිවෙකුට හෙළි නොකළ යුතුය."
      }
    ]
  },
  {
    "key": "btn_leaver_q_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      },
      {
        "language": "FR",
        "text": "Retour"
      },
      {
        "language": "HI",
        "text": "पिछला"
      },
      {
        "language": "TA",
        "text": "Bumalik"
      },
      {
        "language": "UR",
        "text": "پچھلا"
      },
      {
        "language": "BN",
        "text": "পূর্ববর্তী"
      },
      {
        "language": "NL",
        "text": "rug"
      },
      {
        "language": "ES",
        "text": "atrás"
      },
      {
        "language": "LA",
        "text": "retro"
      },
      {
        "language": "ML",
        "text": "തിരികെ"
      },
      {
        "language": "ID",
        "text": "kembali"
      },
      {
        "language": "NE",
        "text": "फिर्ता"
      },
      {
        "language": "SI",
        "text": "ආපසු"
      },
      {
        "language": "TR",
        "text": "Geri"
      }
    ]
  },
  {
    "key": "txt_all_questions_are_required",
    "text": "Please answer the question to continue",
    "translations": [
      {
        "language": "AR",
        "text": "الرجاء إجابة السؤال للاستمرار"
      },
      {
        "language": "FR",
        "text": "Veuillez répondre ŕ la question pour continuer"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_wrong_text_count",
    "text": "Exceeded text limit.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز عدد الأحرف المسموح به"
      },
      {
        "language": "FR",
        "text": "Limite de texte dépassée."
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق"
      },
      {
        "language": "FR",
        "text": "Fermer"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_leaver_q_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "FR",
        "text": "Suivant"
      },
      {
        "language": "HI",
        "text": "अगला"
      },
      {
        "language": "TA",
        "text": "Susunod"
      },
      {
        "language": "UR",
        "text": "اگلا"
      },
      {
        "language": "BN",
        "text": "পরবর্তী"
      },
      {
        "language": "NL",
        "text": "Volgende"
      },
      {
        "language": "ES",
        "text": "Próximo"
      },
      {
        "language": "LA",
        "text": "deinde"
      },
      {
        "language": "ML",
        "text": "അടുത്തത്"
      },
      {
        "language": "ID",
        "text": "Berikutnya"
      },
      {
        "language": "NE",
        "text": "अर्को"
      },
      {
        "language": "SI",
        "text": "ඊළඟ"
      },
      {
        "language": "TR",
        "text": "Sonraki"
      }
    ]
  },
  {
    "key": "btn_leaver_q_submit",
    "text": "Submit",
    "translations": [
      {
        "language": "AR",
        "text": "تسليم"
      },
      {
        "language": "FR",
        "text": "Soumettre"
      },
      {
        "language": "HI",
        "text": "प्रस्तुत करें"
      },
      {
        "language": "TA",
        "text": "Ipasa"
      },
      {
        "language": "UR",
        "text": "جمع کریں"
      },
      {
        "language": "BN",
        "text": "জমা দিন"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "TR",
        "text": "Gönder"
      }
    ]
  },
  {
    "key": "txt_to_complete",
    "text": "Time to complete",
    "translations": [
      {
        "language": "AR",
        "text": "الوقت لاستكمال الاستبيان"
      },
      {
        "language": "FR",
        "text": "Pour compléter"
      },
      {
        "language": "HI",
        "text": "को पूरा करने के"
      },
      {
        "language": "TA",
        "text": "Upang makumpleto ang"
      },
      {
        "language": "UR",
        "text": "میں مکمل کیا جائے"
      },
      {
        "language": "NL",
        "text": "Tijd om te voltooien"
      },
      {
        "language": "ES",
        "text": "tiempo para completar"
      },
      {
        "language": "LA",
        "text": "Tempus ad perficiendam"
      },
      {
        "language": "ML",
        "text": "പൂർത്തിയാക്കാനുള്ള സമയം"
      },
      {
        "language": "ID",
        "text": "Saatnya menyelesaikan"
      },
      {
        "language": "NE",
        "text": "पूरा गर्न समय"
      },
      {
        "language": "SI",
        "text": "සම්පූර්ණ කිරීමට කාලය"
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_to_completeAssessment",
    "text": "Time to complete",
    "translations": [
      {
        "language": "AR",
        "text": "الوقت للإكمال"
      },
      {
        "language": "FR",
        "text": "Pour compléter"
      },
      {
        "language": "HI",
        "text": "को पूरा करने के"
      },
      {
        "language": "TA",
        "text": "Upang makumpleto ang"
      },
      {
        "language": "UR",
        "text": "میں مکمل کیا جائے"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Questions",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة"
      },
      {
        "language": "FR",
        "text": "Questions"
      },
      {
        "language": "HI",
        "text": "प्रश्न"
      },
      {
        "language": "TA",
        "text": "Mga Tanong"
      },
      {
        "language": "UR",
        "text": "سوالات"
      },
      {
        "language": "BN",
        "text": "টি প্রশ্ন"
      },
      {
        "language": "NL",
        "text": "Vragen"
      },
      {
        "language": "ES",
        "text": "Preguntas"
      },
      {
        "language": "LA",
        "text": "Quaestiones"
      },
      {
        "language": "ML",
        "text": "ചോദ്യങ്ങൾ"
      },
      {
        "language": "ID",
        "text": "Pertanyaan"
      },
      {
        "language": "NE",
        "text": "प्रश्नहरू"
      },
      {
        "language": "SI",
        "text": "ප්රශ්නය"
      }
    ]
  },
  {
    "key": "txt5_7minutes",
    "text": "10 - 15 mins",
    "translations": [
      {
        "language": "AR",
        "text": "10 - 15 دقيقة"
      },
      {
        "language": "FR",
        "text": "10 – 15 mins"
      },
      {
        "language": "HI",
        "text": "10 - 15 मिनट"
      },
      {
        "language": "TA",
        "text": "10 - 15 min"
      },
      {
        "language": "UR",
        "text": "10 - 15 منٹ"
      },
      {
        "language": "BN",
        "text": "10 - 15 মিনিট"
      },
      {
        "language": "NL",
        "text": "10 – 15 mins"
      },
      {
        "language": "ES",
        "text": "10 – 15 minutos"
      },
      {
        "language": "LA",
        "text": "10 – 15 mins"
      },
      {
        "language": "ML",
        "text": "10 – 15 മിനിറ്റ്"
      },
      {
        "language": "ID",
        "text": "10 – 15 menit"
      },
      {
        "language": "NE",
        "text": "10 – 15 मिनेट"
      },
      {
        "language": "SI",
        "text": "10 – 15 මිනිත්තු "
      }
    ]
  },
  {
    "key": "txtEngagement",
    "text": "Employee Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Engagement de l'Employé"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  },
  {
    "key": "txt10_15minutes",
    "text": "5 ~ 10 mins",
    "translations": [
      {
        "language": "AR",
        "text": "5 ~ 10 دقيقة"
      },
      {
        "language": "FR",
        "text": "5 ~ 10 mins"
      },
      {
        "language": "FR",
        "text": "5 ~ 10 mins"
      },
      {
        "language": "HI",
        "text": "5 ~ 10 मिनट"
      },
      {
        "language": "TA",
        "text": "5 ~ 10 min"
      },
      {
        "language": "UR",
        "text": "5 ~ 10 منٹ"
      },
      {
        "language": "BN",
        "text": "5 ~ 10 মিনিট"
      },
      {
        "language": "NL",
        "text": "10 – 15 mins"
      },
      {
        "language": "ES",
        "text": "10 – 15 minutos"
      },
      {
        "language": "LA",
        "text": "10 – 15 mins"
      },
      {
        "language": "ML",
        "text": "10 – 15 മിനിറ്റ്"
      },
      {
        "language": "ID",
        "text": "10  - 15 menit"
      },
      {
        "language": "NE",
        "text": "10 – 15 मिनेट"
      },
      {
        "language": "SI",
        "text": "10 – 15 මිනිත්තු "
      }
    ]
  },
  {
    "key": "txtEngagementSurvey",
    "text": "Employee Engagement Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Enquęte d'Engagement"
      },
      {
        "language": "HI",
        "text": "कर्मचारी सहभागिता सर्वेक्षण"
      },
      {
        "language": "TA",
        "text": "Employee Engagement Survey"
      },
      {
        "language": "UR",
        "text": "ملازمین کی مصروفیت کا سروے"
      },
      {
        "language": "BN",
        "text": "কর্মচারী নিয়োগ সমীক্ষা"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      }
    ]
  },
  {
    "key": "txtHappinessSurvey",
    "text": "Employee Happiness Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان سعادة الموظف"
      },
      {
        "language": "NL",
        "text": "Onderzoek naar medewerkersgeluk"
      },
      {
        "language": "ES",
        "text": "Encuesta de felicidad de los empleados"
      },
      {
        "language": "LA",
        "text": "Aliquam beatitudo Survey"
      },
      {
        "language": "ML",
        "text": "ജീവനക്കാരുടെ സന്തോഷ സർവേ"
      },
      {
        "language": "ID",
        "text": "Survei Kebahagiaan Karyawan"
      },
      {
        "language": "NE",
        "text": "कर्मचारी खुशी सर्वेक्षण"
      },
      {
        "language": "SI",
        "text": "සේවක සතුට පිළිබඳ සමීක්ෂණය"
      },
      {
        "language": "HI",
        "text": "कर्मचारी खुशी सर्वेक्षण"
      },
      {
        "language": "TA",
        "text": "Survey sa Kaligayahan ng Empleyado"
      },
      {
        "language": "UR",
        "text": "ملازمین کی خوشی کا سروے"
      },
      {
        "language": "BN",
        "text": "কর্মচারী সুখ সমীক্ষা"
      }
    ]
  },
  {
    "key": "txtSection",
    "text": "Section",
    "translations": [
      {
        "language": "AR",
        "text": "قسم"
      },
      {
        "language": "FR",
        "text": "Section"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "LA",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "HI",
        "text": ""
      },
      {
        "language": "TA",
        "text": ""
      },
      {
        "language": "UR",
        "text": ""
      },
      {
        "language": "BN",
        "text": ""
      }
    ]
  }
]